import Fetcher from '../util/fetcher';

/**
 * Makes life easier for the user admin panel. This bundles all calls to the fetcher and notifies when updates to the
 * user list have taken place.
 */
class UserStore {

  constructor(fbToken) {
    this.firebaseToken = fbToken;
    this.fetcher = new Fetcher(fbToken);
  }

  errorFeedback = error => {
    this.dispatchLoadComplete();
    alert('Something with wrong with your request. Please reload the page and try again.');
  }
  
  refreshUserList() {
    this.dispatchLoadStart();
    return this.fetcher.adminFetchUserList()
      .then(response => {
        this.dispatchLoadComplete();
        this.onListUpdate && this.onListUpdate(response.data);
      })
      .catch(this.errorFeedback);
  }

  dispatchLoadStart() {
    this.onLoadStart && this.onLoadStart();
  }

  dispatchLoadComplete() {
    this.onLoadComplete && this.onLoadComplete();
  }

  update(user, shouldMail) {
    this.dispatchLoadStart();
    return this.fetcher.adminUserUpdate(user, shouldMail)
      .then(response => {
        this.refreshUserList();
        return response.data;
      })
      .catch(this.errorFeedback);
  }
  
  create(user, shouldMail) {
    this.dispatchLoadStart();
    return this.fetcher.adminUserCreate(user, shouldMail)
      .then(response => {
        this.refreshUserList();
        return response.data;
      })
      .catch(this.errorFeedback);
  }

  disable(user) {
    this.dispatchLoadStart();
    return this.fetcher.adminUserDisable(user.uid)
      .then(response => {
        this.refreshUserList();
        return response.data;
      })
      .catch(this.errorFeedback);
  }

  enable(user) {
    this.dispatchLoadStart();
    return this.fetcher.adminUserEnable(user.uid)
      .then(response => {
        this.refreshUserList();
        return response.data;
      })
      .catch(this.errorFeedback);
  }

  delete(user) {
    this.dispatchLoadStart();
    return this.fetcher.adminUserDelete(user.uid)
      .then(response => {
        this.refreshUserList();
        return response.data;
      })
      .catch(this.errorFeedback);
  }
}

export default UserStore;



// WEBPACK FOOTER //
// ./src/util/UserStore.js